import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const ProjectModal = ({ project, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    tag_ar: '',
    tag_en: '',
    title_ar: '',
    title_en: '',
    image_url: '',
    display_order: 0,
    is_active: true
  });
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (project) {
      setFormData({
        tag_ar: project.tag_ar || '',
        tag_en: project.tag_en || '',
        title_ar: project.title_ar || '',
        title_en: project.title_en || '',
        image_url: project.image_url || '',
        display_order: project.display_order || 0,
        is_active: project.is_active !== undefined ? project.is_active : true
      });
    }
  }, [project]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('image', file);

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/upload/image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      if (data.success) {
        const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net';
        const imageUrl = `${baseUrl}${data.url.startsWith('/') ? data.url : `/${data.url}`}`;
        handleChange('image_url', imageUrl);
      }
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.image_url) {
      alert('يرجى إضافة رابط الصورة');
      return;
    }
    onSave(formData);
  };

  return (
    <div className="editor-modal-overlay" onClick={onClose}>
      <div className="editor-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="editor-modal-header">
          <h2>{project ? 'تعديل المشروع' : 'إضافة مشروع جديد'}</h2>
          <button className="editor-modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="editor-grid">
            <div className="editor-column">
              <h3>المحتوى العربي</h3>
              <div className="editor-form-group">
                <label>العلامة</label>
                <input
                  type="text"
                  value={formData.tag_ar}
                  onChange={(e) => handleChange('tag_ar', e.target.value)}
                />
              </div>
              <div className="editor-form-group">
                <label>العنوان</label>
                <input
                  type="text"
                  value={formData.title_ar}
                  onChange={(e) => handleChange('title_ar', e.target.value)}
                />
              </div>
            </div>

            <div className="editor-column">
              <h3>المحتوى الإنجليزي</h3>
              <div className="editor-form-group">
                <label>Tag (English)</label>
                <input
                  type="text"
                  value={formData.tag_en}
                  onChange={(e) => handleChange('tag_en', e.target.value)}
                />
              </div>
              <div className="editor-form-group">
                <label>Title (English)</label>
                <input
                  type="text"
                  value={formData.title_en}
                  onChange={(e) => handleChange('title_en', e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="editor-form-group">
            <label>رابط الصورة *</label>
            <div className="editor-image-input">
              <input
                type="text"
                value={formData.image_url}
                onChange={(e) => handleChange('image_url', e.target.value)}
                placeholder="رابط الصورة أو رفع ملف"
                required
              />
              <label className="editor-upload-btn">
                {uploading ? 'جاري الرفع...' : 'رفع صورة'}
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                  disabled={uploading}
                />
              </label>
            </div>
            {formData.image_url && (
              <img src={formData.image_url} alt="Preview" className="editor-image-preview" />
            )}
          </div>

          <div className="editor-form-group">
            <label>ترتيب العرض</label>
            <input
              type="number"
              value={formData.display_order}
              onChange={(e) => handleChange('display_order', parseInt(e.target.value) || 0)}
            />
          </div>

          <div className="editor-actions">
            <button type="submit" className="editor-btn-save" disabled={uploading}>
              {project ? 'حفظ التغييرات' : 'إضافة المشروع'}
            </button>
            <button type="button" className="editor-btn-secondary" onClick={onClose}>
              إلغاء
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectModal;

